import React from "react";
import { Container, Wrapper } from "./styles";
import Menu from "../../Components/Menu";
import Footer from "../../Components/Footer";
import { FotoPriscila, FotoZair, sloganSobreNos } from "../../Components/imgs";

import {
	LuBicepsFlexed,
	LuBrain,
	LuDna,
	LuFlame,
	LuLightbulb,
	LuMicroscope,
	LuSalad,
} from "react-icons/lu";
import { BsInstagram, BsLinkedin, BsWhatsapp } from "react-icons/bs";

export default function About() {
	document.title = "DNA for Performance - Quem somos?";

	const whatsappMessage = encodeURIComponent(
		"Oii tudo bem? Quero agendar minha análise"
	);

	const whatsappLink = `https://wa.me/5541984146397?text=${whatsappMessage}%21`;

	return (
		<>
			<Menu />
			<Container>
				<Wrapper>
					<div className="top-content">
						<h1>
							Quem é <strong>DNA For Performance</strong>?
						</h1>
						<span>
							Ciência que inspira confiança. Tecnologia que entrega resultados.
						</span>

						<span>
							Nós da DNA For Performance, entendemos que a otimização da sua
							performance já está descrita no seu DNA, basta conhecê-lo! <br />
							<strong>
								Ciência que inspira confiança. Tecnologia que
								entrega resultados.
							</strong>
						</span>
						<p>
							Nossa empresa foi idealizada a partir da expertise de dois
							professores doutores com sólida trajetória acadêmica e
							profissional nas áreas de Nutrição, Educação Física e Genética
							Aplicada. Ou seja, nossa reputação no meio esportivo vai além dos
							títulos e se dá pelo trabalho de anos com pesquisa de ponta,
							constante atualização científica e entrega de resultados práticos
							aos nossos esportistas!
						</p>

						{/* <ul>
							<li>
								<p>Transformamos genética em ação</p>
							</li>
							<li>
								<p>Informação em estratégia</p>
							</li>
							<li>
								<p>Ciência em performance</p>
							</li>
						</ul> */}

						<div className="Slogan-wrapper">
							<img
								src={sloganSobreNos}
								alt="Transformamos genética em ação, Informação em estratégia, Ciência em performance"
							/>
						</div>

						<p>
							Com quase{" "}
							<strong>1500 genes e mais de 5000 snps (polimorfismos)</strong>{" "}
							selecionados por sua relevância direta nos processos fisiológicos
							que determinam a performance.
						</p>

						<div className="mid_info-area">
							<p>
								Ao contrário de muitos exames genéticos disponíveis no mercado
								que são meramente recreativos, pois fazem análises superficiais
								de genes com pouca aplicabilidade prática, o nosso foi projetado
								a partir de um mapeamento cuidadoso das rotas metabólicas
								essenciais, que refletem aspectos importantes da fisiologia do
								exercício e resposta a dieta e treinos específicos, considerando
								os principais genes relacionados a:
							</p>

							<ul>
								<li>
									<LuMicroscope />
									<p>Metabolismo energético</p>
								</li>
								<li>
									<LuBicepsFlexed />
									<p>Potencial de força e resistência</p>
								</li>
								<li>
									<LuDna />
									<p>Risco de lesões musculares e articulares</p>
								</li>
								<li>
									<LuBrain />
									<p>Resposta hormonal ao exercicio</p>
								</li>
								<li>
									<LuFlame />
									<p>Capacidade antioxidante e combate aos radicais livres</p>
								</li>
								<li>
									<LuLightbulb />
									<p>Termoregularização e adaptação ao esforço físico</p>
								</li>
								<li>
									<LuSalad />
									<p>
										Perfil genético nutricional para suplementação de precisão
									</p>
								</li>
							</ul>
						</div>
						<span>
							Nosso painel não é genérico. É genético. É estratégico.{" "}
							<strong>É seu!</strong>
						</span>
					</div>

					<div className="info-area">
						<h1>
							Quem está por trás da <strong>Dna For Performance</strong>?
						</h1>
						<div className="block" id="priscila">
							<img
								src={FotoPriscila}
								alt="mulher de pele clara, cabelos loiros e vestido azul estampado"
							/>
							<div className="info">
								<div>
									<h2>Profa. Dra. Priscila Dabaghi Barbosa</h2>
								</div>
								<ul>
									<li>Doutora em Biotecnologia Industrial (UP)</li>
									<li>Mestrado em Ciências – Bioquímica (UFPR)</li>
									<li>Graduada em Nutrição (UFPR)</li>
									<li>
										Coordenadora de cursos de Nutrição da Universidade Positivo.{" "}
										<strong>Há 25 anos no magistério do ensino superior</strong>
										, atuante em pesquisas na área de Nutrição Esportiva,
										Metabolismo Energético, Antioxidantes e Desenvolvimento de
										Produtos Nutricionais para Fins Especiais, além de possuir{" "}
										<strong>
											vasta experiência em atendimentos nutricionais de
											desportistas e atletas.
										</strong>
									</li>
								</ul>
								<a
									href="http://lattes.cnpq.br/2139105784405579"
									target="_blank"
									rel="noreferrer">
									Currículo completo
								</a>
							</div>
						</div>

						<div className="block" id="zair">
							<div className="info">
								<div>
									<h2>Prof. Dr. Zair Candido de Oliveira Netto</h2>
								</div>
								<ul>
									<li>
										Doutor em Ciências da Saúde (UCAM/Espanha – reconhecido pela
										UFPR)
									</li>
									<li>Mestre em Engenharia Biomédica (UTFPR)</li>
									<li>
										Especialista em Fisiologia do Exercício (PUC-PR) e Exercício
										e Saúde (UFPR)
									</li>
									<li>Graduado em Educação Física (UFPR)</li>
									<li>Membro do Conselho Municipal do Esporte em Curitiba</li>
									<li>
										Coordenador do Curso de Educação Física da Universidade
										Positivo Atua em pesquisas sobre{" "}
										<strong>
											esportes de combate, percepção de esforço e polimorfismos
											genéticos ligados à performance
										</strong>
									</li>
								</ul>

								<a
									target="_blank"
									href="http://lattes.cnpq.br/5531750758912918"
									rel="noreferrer">
									Currículo completo
								</a>
							</div>
							<img
								src={FotoZair}
								alt="rapaz de pele clara vestindo um blazer com uma camisa social branca."
							/>
						</div>

						<h1>
							Na DNA For Performance, confiança é o nosso DNA. <br />
							<span>E a sua evolução é o nosso compromisso.</span>
						</h1>
					</div>

					{/* <div className="maps">
						<h3>Veja no mapa: </h3>
						<iframe
							title="maps"
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1801.3661155545087!2d-49.360208361127825!3d-25.447214222401044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94dce20447a978ed%3A0x9f4a2fb025c06630!2sPositive%20University!5e0!3m2!1sen!2sbr!4v1745075707248!5m2!1sen!2sbr"
							loading="eager"
							style={{ border: "none", outline: "transparent", opacity: 0.8 }}
							about="Universidade Positivo <br />
								Pedro Viriato Parigot de Souza 5300 <br /> Bloco Vermelho –
								Espaço Ecohub"
							referrerpolicy="no-referrer-when-downgrade"></iframe>
						<a
							target="_blank"
							href="https://maps.app.goo.gl/q1WC3HNS9bK8WgXs9"
							rel="noreferrer">
							universidade positivo - R. Prof. Pedro Viriato Parigot de Souza,
							5300 - Cidade Industrial, Curitiba - PR, 81280-330
						</a>
					</div> */}

					<div className="social-wrapper">
						<h2>Nossas redes:</h2>
						<ul>
							<li>
								<a
									href="https://www.instagram.com/dnaforperformance/"
									target="_blank"
									rel="noreferrer">
									<BsInstagram /> Nosso Instagram
								</a>
							</li>
							<li>
								{" "}
								<a
									href="https://www.instagram.com/dnaforperformance/"
									target="_blank"
									rel="noreferrer">
									<BsLinkedin /> Nosso Linkedin
								</a>
							</li>
							<li>
								<a href={whatsappLink} target="_blank" rel="noreferrer">
									<BsWhatsapp /> Nosso Whatsapp
								</a>
							</li>
						</ul>
					</div>
				</Wrapper>
			</Container>
			<Footer />
		</>
	);
}
